import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'resourceSecureBlob'
})
export class ResourceSecureBlobPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(blob): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob) + '#toolbar=0&navpanes=0');
  }
}
